import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { SearchIcon, CrossIcon, SelectBase } from 'components'
import { Radium } from 'higher-order-components'
import { bindAll } from 'utils'
import classNames from './style.css'

const Clear = () => (
  <div
    style={[
      styles.svgContainer,
      {
        width: '1em',
        height: '1em',
        transition: 'color .25s',
        marginLeft: '1em',
        ':hover': {
          color: '#191919'
        }
      },
      { zIndex: 3 }
    ]}>
    <CrossIcon style={styles.svgBase} />
  </div>
)

const EnhancedClear = Radium(Clear)

export class SearchSelectBox extends PureComponent {
  constructor(props) {
    super(props)
    this.field = {
      focus: false,
      value: ''
    }
    bindAll(['renderSearch', 'renderClear'], this)
  }
  static propTypes = {
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
  }

  render() {
    const { onBlur, onFocus, ...props } = this.props
    const selectProps = {
      clearRenderer: () => <EnhancedClear />,
      arrowRenderer: () => {},
      onFocus: () => {
        this.setState({ focus: true })
        onFocus && onFocus()
      },
      onBlur: () => {
        this.setState({ focus: false })
        onBlur && onBlur()
      },
      ...props
    }
    return (
      <div style={[styles.container, this.state.focus ? styles.focus : { borderColor: '#D5D5D5' }]}>
        <div style={[styles.svgContainer, { height: '1.2em', width: '1.2em', marginRight: '1em' }]}>
          <SearchIcon style={styles.svgBase} />
        </div>
        <div style={{ flex: '1 1 100%', marginBottom: "-1px" }}>
          <SelectBase className={classNames.__SearchSelectBox} {...selectProps} />
        </div>
      </div>
    )
  }
}

SearchSelectBox.defaultProps = {
  placeholder: 'Search',
  value: ''
}

export default Radium(SearchSelectBox)

const styles = {
  svgContainer: {
    position: 'relative',
    color: '#979797'
  },
  svgBase: {
    fill: 'currentColor',
    height: '100%',
    width: '100%'
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    transition: 'border-color .25s',
    borderBottom: '1px solid',
    padding: '0 .5em'
  },
  focus: {
    boxShadow: '0 1px 0 rgba(0, 0, 0, 0.06)'
  }
}



// WEBPACK FOOTER //
// ./src/containers/search-select-box/index.jsx